import { decimalFixed, decimalFixedMid } from "./consts";

export const formatDecimalNumber = (number, countOfZeros = null, toLower = false) => {
  if (number === null || number === undefined) {
    return 0;
  }

  let numberString = number.toString();
  let decimalPart = numberString.split(".")[1];

  decimalPart = decimalPart ? decimalPart.replace(/0+$/, "") : "0";

  if (countOfZeros && !parseInt(decimalPart.slice(0, countOfZeros))) {
    countOfZeros = countOfZeros < decimalFixedMid ? decimalFixedMid : decimalFixed;
  }

  countOfZeros = countOfZeros ?? (decimalPart ? decimalPart.length : 0);
  const multiplier = 10 ** countOfZeros;

  if (!isNaN(number)) {
    number = toLower ? Math.floor(number * multiplier) / multiplier : parseFloat(number).toFixed(countOfZeros);

    if (Number.isInteger(number)) {
      return number.toString();
    } else {
      let numberString = transformENumber(number).toString();
      let integerPart = numberString.split(".")[0];
      let decimalPart = numberString.split(".")[1];

      if (decimalPart) {
        decimalPart = decimalPart.slice(0, countOfZeros);
        decimalPart = decimalPart.replace(/0+$/, "");

        if (decimalPart.length === 0) {
          return integerPart;
        }

        return integerPart + "." + decimalPart;
      } else {
        return integerPart;
      }
    }
  }

  return 0;
};

export const transformENumber = (num) => {
  if (num.toString().includes("e-")) {
    const splitedArr = num.toString().split("e-");
    return num.toFixed(splitedArr[1]);
  } else {
    return num;
  }
};
